import React, { ReactElement } from 'react';
import dynamic from 'next/dynamic';
import classNames from 'classnames/bind';
import RootLayout from 'layouts/RootLayout';
import { LeadFormParameters } from 'sections/Benefits/data';
import styles from 'styles/pages/Benefits/ShippingLeads/ShippingLeads.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = dynamic(() => import('sections/Benefits/ShippingLeads/components/SectionHeader'));
const SectionPitch = dynamic(() => import('sections/Benefits/ShippingLeads/components/SectionPitch'));
const SectionCards = dynamic(() => import('sections/Benefits/ShippingLeads/components/SectionCards'));
const SectionCallToAction = dynamic(() => import('sections/Benefits/ShippingLeads/components/SectionCallToAction'));
const SectionFaq = dynamic(() => import('sections/Benefits/ShippingLeads/components/SectionFaq'));
const SectionForm = dynamic(() => import('sections/Benefits/ShippingLeads/components/SectionForm'));

type ShippingLeadsProps = {
  pageTitle?: string;
  formUrl?: string;
  leadSubtype?: string;
};

export default function ShippingLeadsPage({ pageTitle, formUrl, leadSubtype }: ShippingLeadsProps) {
  return (
    <div className={cn('shipping-leads')}>
      <SectionHeader/>
      <SectionPitch/>
      <SectionCards/>
      <SectionCallToAction/>
      <SectionFaq/>
      <SectionForm 
        pageTitle={pageTitle} 
        formUrl={formUrl} 
        leadSubtype={leadSubtype}
      />
    </div> 
  );
}

export const getStaticProps = async () => {
  // 'FormParameters' - parameters, passed to 'Form' component on all Benefits pages as an additional data: 
  const FormParameters = {
    pageTitle: LeadFormParameters.shippingLeads.pageTitle,
    formUrl: LeadFormParameters.shippingLeads.formUrl,
    leadSubtype: LeadFormParameters.shippingLeads.leadSubtype,
  };

  return {
    props: {
      title: 'Shipping Leads for Freight Forwarders | DF Alliance',
      description:
        'Access exclusive shipping leads from DF Alliance to boost your business opportunities and streamline your global logistics with quality prospects and partners.',
      path: '/benefits/shipping-leads',
      ...FormParameters,
    },
  };
};

ShippingLeadsPage.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
